import { Link } from "react-router-dom";
import Obsessionslogo from "../../assets/images/logo-dark.png";
const PageNotFound = () => {
    const linkStyle = {
        fontFamily: "verdana,arial,helvetica,sans-serif",
        color: "#004B91",
    };

    const containerStyle = {
        fontFamily: "verdana,arial,helvetica,sans-serif",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
    };

    return (
        <div style={containerStyle} className="mt-4">
            <Link
                to="/"
                state={{ ref: "404_logo" }}
            >
                <img src={Obsessionslogo} alt="Obsessions Logo" width={150} />
            </Link>
            <table border="0" align="center" style={{ marginTop: "20px" }}>
                <tbody>
                    <tr>
                        <td>
                            <b style={{ color: "#e44211" }}>Looking for something?</b>
                            <br />
                            We're sorry. The Web address you entered is not a functioning page
                            on our site.
                            <br />
                            <br />
                            <b>
                                <a href="/" style={linkStyle}>
                                    Click here to go back to the Obsessions home page
                                </a>
                            </b>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
export default PageNotFound;